selectDetailContenType